// src/themes/dark.ts
import {
  borders as borders2,
  darkTheme as sharedDarkTheme
} from "@brexhq/metal-foundation-shared";

// src/borders.ts
import { borders } from "@brexhq/metal-foundation-shared";
import { border } from "polished";
var getDefaultBorder = (theme) => ({
  /** Applies the default border style to all border sides */
  all: border(borders.width.default, "solid", theme.colors.border.default),
  /** Applies the default border style only to the top border */
  top: border(
    "top",
    borders.width.default,
    "solid",
    theme.colors.border.default
  ),
  /** Applies the default border style only to the right border */
  right: border(
    "right",
    borders.width.default,
    "solid",
    theme.colors.border.default
  ),
  /** Applies the default border style only to the bottom border */
  bottom: border(
    "bottom",
    borders.width.default,
    "solid",
    theme.colors.border.default
  ),
  /** Applies the default border style only to the left border */
  left: border(
    "left",
    borders.width.default,
    "solid",
    theme.colors.border.default
  )
});

// src/colors.ts
import { palette } from "@brexhq/metal-foundation-shared";
var colors = {
  cardPhysicalBackground: palette.neutrals.coolGrey12,
  cardPhysicalWave: palette.neutrals.pitchBlack,
  cardVendorBackground: palette.neutrals.coolGrey3,
  cardMetalGradient: "linear-gradient(130deg, #EFB97C 11.65%, #9D704A 89.71%)",
  cardMetalGradientMuted: "linear-gradient(130deg, rgba(239, 185, 124, 0.5) 11.65%, rgba(157, 112, 74, 0.5) 89.71%)",
  selected: palette.cerulean[1],
  selectedHover: palette.cerulean[2]
};

// src/scrollbarOverrides.ts
import { transparentize } from "polished";
var getScrollbarOverrides = (theme) => ({
  "::-webkit-scrollbar": {
    width: 8
  },
  "::-webkit-scrollbar-track": {
    borderRadius: 5,
    background: transparentize(0.9, theme.colors.content.primary)
  },
  "::-webkit-scrollbar-thumb": {
    borderRadius: 5,
    background: transparentize(0.7, theme.colors.content.primary)
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: transparentize(0.6, theme.colors.content.primary)
  },
  "::-webkit-scrollbar-thumb:window-inactive": {
    background: transparentize(0.95, theme.colors.content.primary)
  }
});

// src/themes/shared.ts
import {
  animations,
  shadows,
  spacing,
  typography,
  zIndex
} from "@brexhq/metal-foundation-shared";

// src/breakpoints.ts
var ViewportSizes = /* @__PURE__ */ ((ViewportSizes2) => {
  ViewportSizes2[ViewportSizes2["Desktop"] = 1800] = "Desktop";
  ViewportSizes2[ViewportSizes2["TabletLandscape"] = 1200] = "TabletLandscape";
  ViewportSizes2[ViewportSizes2["SmallDesktop"] = 960] = "SmallDesktop";
  ViewportSizes2[ViewportSizes2["TabletPortrait"] = 900] = "TabletPortrait";
  ViewportSizes2[ViewportSizes2["Phone"] = 600] = "Phone";
  return ViewportSizes2;
})(ViewportSizes || {});
function generateMediaQueryString(viewportSize) {
  return `@media (max-width: ${viewportSize}px)`;
}
var breakpointKeysAsc = [
  "phone",
  "tabletPortrait",
  "smallDesktop",
  "tabletLandscape",
  "desktop"
];
var breakpoints = {
  desktop: generateMediaQueryString(1800 /* Desktop */),
  phone: generateMediaQueryString(600 /* Phone */),
  smallDesktop: generateMediaQueryString(960 /* SmallDesktop */),
  tabletLandscape: generateMediaQueryString(1200 /* TabletLandscape */),
  tabletPortrait: generateMediaQueryString(900 /* TabletPortrait */)
};

// src/themes/shared.ts
var webShared = {
  animations,
  breakpoints,
  colors,
  shadows,
  spacing,
  typography,
  zIndex
};

// src/themes/dark.ts
var colors2 = {
  ...sharedDarkTheme.colors,
  ...colors,
  illustrationGradient: "linear-gradient(180deg, #111111 0%, #212121 100%)"
};
var darkTheme = {
  ...sharedDarkTheme,
  ...webShared,
  borders: {
    ...borders2,
    /** Shorthand that applies default `border` styles (`border-color`, `border-width`, and `border-style`).
     *
     * `"all" | "top" | "right" | "bottom" | "left"`
     *
     * @example
     * const MyComponent = styled.div(({ theme }) => ({
     * ...theme.borders.defaultBorder.all,
     * // Other styles
     * }));
     */
    defaultBorder: getDefaultBorder(sharedDarkTheme)
  },
  scrollbarOverrides: getScrollbarOverrides(sharedDarkTheme),
  colors: colors2
};

// src/themes/light.ts
import {
  borders as borders3,
  lightTheme as sharedLightTheme
} from "@brexhq/metal-foundation-shared";
var colors3 = {
  ...sharedLightTheme.colors,
  ...colors,
  illustrationGradient: "linear-gradient(180deg, #E0D9D1 0%, #EFEBE6 100%)"
};
var lightTheme = {
  ...sharedLightTheme,
  ...webShared,
  borders: {
    ...borders3,
    /** Shorthand that applies default `border` styles (`border-color`, `border-width`, and `border-style`).
     *
     * `"all" | "top" | "right" | "bottom" | "left"`
     *
     * @example
     * const MyComponent = styled.div(({ theme }) => ({
     * ...theme.borders.defaultBorder.all,
     * // Other styles
     * }));
     */
    defaultBorder: getDefaultBorder(sharedLightTheme)
  },
  scrollbarOverrides: getScrollbarOverrides(sharedLightTheme),
  colors: colors3
};
export {
  ViewportSizes,
  breakpointKeysAsc,
  breakpoints,
  darkTheme,
  lightTheme
};
